import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ProvenImpactSection = () => {
  const impacts = [
    {
      icon: '🌍',
      title: '巴黎 UNESCO 國際教育日論壇',
      tag: 'International',
      description: '創辦人作為未來青年智慧發展中心主席代表世界永續領袖峰會親赴聯合國教科文組織總部參與 2026 國際教育日論壇。'
    },
    {
      icon: '🏢',
      title: '全球 500 強企業 × 金融機構',
      tag: 'Enterprise',
      description: '員工金錢心理健康工作坊與高階心智壓力測試，覆蓋跨國科技與金融體系。'
    },
    {
      icon: '🎓',
      title: '台灣數十所國中小學',
      tag: 'Education',
      description: '在地生命教育深耕，與教育現場共同陪伴下一代的金錢觀與能動性。'
    },
    {
      icon: '📊',
      title: '300+ 場次 · 30+ 國家 · 萬人觸及',
      tag: 'Scale',
      description: '線上與線下混合活動，量化口碑實證的全球影響力。'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="text-orange-400 text-sm font-medium tracking-wider mb-4">
              PROVEN IMPACT
            </div>
            <h2 className="text-4xl lg:text-5xl font-serif text-gray-900 mb-4">
              從巴黎 UNESCO 到<br />全球三十國的真實閉環
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              我們不只談理論——七年深耕、百萬大數據壓力測試、跨國權威背書，每一場活動都是一次系統的真實驗證。
            </p>
          </div>

          {/* Impact Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {impacts.map((impact, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 border border-orange-100 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="text-4xl">{impact.icon}</div>
                  <div className="flex-1">
                    <div className="inline-block px-3 py-1 bg-orange-100 text-orange-600 text-xs font-medium rounded-full mb-3">
                      {impact.tag}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {impact.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {impact.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvenImpactSection;
